import { useOfflineQueue } from '../../hooks/useOfflineQueue'

export default function OfflineBanner() {
  const { isOnline, pendingCount } = useOfflineQueue()

  if (isOnline && pendingCount === 0) return null

  return (
    <div
      className={`offline-banner ${isOnline ? 'bg-blue-500' : 'bg-yellow-500'}`}
      role="status"
      aria-live="polite"
    >
      {!isOnline
        ? '⚡ أنت غير متصل بالإنترنت — سيتم حفظ طلبك وإرساله عند عودة الاتصال'
        : `🔄 جارٍ إرسال ${pendingCount} طلب محفوظ...`}
    </div>
  )
}
